




























import Vue from 'vue'
import Project from '@/components/Project.vue'
import Button from '@/components/Button.vue'
import SentIcon from '@/components/icons/SentIcon.vue'

export default Vue.extend({
  name: 'Home',
  data() {
    return {
      projects: require('@/assets/projects.json')
    }
  },
  beforeMount() {
    document.body.scrollTop = 0
  },
  components: {
    Project,
    Button,
    SentIcon
  }
})
